import { render } from "./ComprasRecibir.vue?vue&type=template&id=cde0d008&scoped=true"
import script from "./ComprasRecibir.vue?vue&type=script&lang=js"
export * from "./ComprasRecibir.vue?vue&type=script&lang=js"

import "./ComprasRecibir.vue?vue&type=style&index=0&id=cde0d008&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde0d008"]])

export default __exports__